import { CURRENCIES, type Currency } from '@chukua/common';
import { Form, Input, Select } from 'antd';
import { parseMoneyAmount } from '../../../../../shared/policies/parse-money-amount';

const CURRENCY_OPTIONS = CURRENCIES.map((currency) => ({ value: currency, label: currency }));

/** The estimate and its currency in one control. The amount is checked against the chosen currency's minor units. */
export function EstimateField() {
  const form = Form.useFormInstance();

  return (
    <Form.Item
      name="estimate"
      label="Estimated cost"
      dependencies={['currency']}
      rules={[
        {
          validator: (_, value?: string) => {
            const check = parseMoneyAmount(value, form.getFieldValue('currency') as Currency);
            return check.ok ? Promise.resolve() : Promise.reject(new Error(check.reason));
          },
        },
      ]}
    >
      <Input
        inputMode="decimal"
        addonBefore={
          <Form.Item name="currency" noStyle>
            <Select aria-label="Currency" options={CURRENCY_OPTIONS} className="w-20" />
          </Form.Item>
        }
      />
    </Form.Item>
  );
}
